// extracted by css-extract-rspack-plugin
export default {"aiAssist":"aiAssist-tK31C3","aiAssistHint":"aiAssistHint-iR2rcW"};